import Firebase from '../../../lib/Firebase';
import Firestore from '../../../lib/Firestore';

export default {
  all(hotel) {
    return Firebase.firestore()
      .collection('seasons')
      .where("hotel", "==", hotel.docId)
      .get()
      .then(docs => {
       return Firestore.getCollectionData(docs);
      
      });
  },
   roomsfetch(season) {
     console.log("Room Function : " , season)
    return Firebase.firestore()
      .collection('seasons')
      .doc(season.docId)
      .collection('rooms')
      .get()
      .then(docs => {
       return Firestore.getCollectionData(docs);      
      });
  }, 
  al(city) {
    return Firebase.firestore()
      .collection('seasons')
      .where("hotel", "==", city.docId)
      .get()
      .then(docs => {
        return Firestore.getCollectionData(docs);
      });
  },

  manage(id, selectedSeason1, name, rates, serviceCharge, mealPlans ) {
  // console.log("id : ", id);
    console.log("Selected Season : ",selectedSeason1);
    console.log("Service Charge : ",serviceCharge);
     console.log("Room Rates : ", rates);
    console.log("Mealplan : ", mealPlans);  
    const roomsObj = { 
      name : name, 
      serviceCharge : serviceCharge,
      rates,
      mealPlans 
    };
    
    const promise = id
      ? Firebase.firestore()
          .collection('seasons')
          .doc(selectedSeason1.docId)
          .collection('rooms')
          .doc(id)
          .update(roomsObj)
      : Firebase.firestore()
          .collection('seasons')
          .doc(selectedSeason1.docId)
          .collection('rooms')
          .add(roomsObj);
    return promise;
  },

  deleteRoom(season, roomToBeDeleted) {
    console.log("Season Delete" , season.docId);
    console.log("Room Delete" , roomToBeDeleted);
    return Firebase.firestore()
      .collection('seasons')
      .doc(season.docId)
      .collection('rooms')
      .doc(roomToBeDeleted.docId)
      .delete();
  }
};



// WEBPACK FOOTER //
// ./src/pages/hotel/Rooms/service.js